import { BrancheEnum, type NoCommentMeetingParticipant } from "@sgdf/client"

export type Sorter = "firstname" | "lastname" | "nobservations" | "dailytaskteam" | "branche"

export const sorterMap: Record<string, Record<string, (a: NoCommentMeetingParticipant, b: NoCommentMeetingParticipant) => number>> = {
  "firstname": {
    "true": (a, b) => (a.usage_first_name ?? a.first_name).localeCompare(b.usage_first_name ?? b.first_name),
    "false": (a, b) => (b.usage_first_name ?? b.first_name).localeCompare(a.usage_first_name ?? a.first_name),
  },
  "lastname": {
    "true": (a, b) => (a.usage_last_name ?? a.last_name).localeCompare(b.usage_last_name ?? b.last_name),
    "false": (a, b) => (b.usage_last_name ?? b.last_name).localeCompare(a.usage_last_name ?? a.last_name),
  },
  "nobservations": {
    "false": (a, b) => (b.observation_count) - (a.observation_count),
    "true": (a, b) => (a.observation_count) - (b.observation_count),
  },
  "dailytaskteam": {
    "true": (a, b) => (a.daily_task_team?.label ?? "").localeCompare(b.daily_task_team?.label ?? ""),
    "false": (a, b) => (b.daily_task_team?.label ?? "").localeCompare(a.daily_task_team?.label ?? ""),
  },
  "branche": {
    "true": (a, b) => (a.branche ?? BrancheEnum._0).localeCompare(b.branche ?? BrancheEnum._0),
    "false": (a, b) => (b.branche ?? BrancheEnum._0).localeCompare(a.branche ?? BrancheEnum._0),
  }
} satisfies Record<Sorter, Record<"true" | "false", (a: NoCommentMeetingParticipant, b: NoCommentMeetingParticipant) => number>>;

